import { render } from "./RegistrationDoctorCard.vue?vue&type=template&id=52fbf6a2&scoped=true&ts=true"
import script from "./RegistrationDoctorCard.vue?vue&type=script&lang=ts"
export * from "./RegistrationDoctorCard.vue?vue&type=script&lang=ts"

import "./RegistrationDoctorCard.vue?vue&type=style&index=0&id=52fbf6a2&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fbf6a2"]])

export default __exports__